// extracted by mini-css-extract-plugin
export default {"root":"Divider-module--root--51e91","customSpacing":"Divider-module--customSpacing--bf522"};